/**
 * Sections can be handled in details page
 * in two ways, as detail (form, table) or as
 * a widget (tags, brand. etc)
 */
export enum SectionType {
  Details = 'details',
  Widget = 'widget',
}

export enum ApplicationSectionType {
  DetachableSection = 1,
  DetachableTransientSection = 2,
}

export enum ApplicationSectionTypeDesc {
  DetachableSection = 'DetachableSection',
  // TODO: typo must be fixed in BE
  DetachableTransientSection = 'DetachableTranscientSection',
}
